import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { getCompany } from '../../config/companyConfig';

export default function LoaderTransparent({
    fullScreen = false,
    coverParent = false,
    size = 70,
    strokeWidth = 3,
    animationDuration = '.8s',
    overlayTint = 'rgba(0, 0, 0, 0.06)',
    overlayBlur = '4px',
    blockInteraction = true,
    status = 'loading',
    loadingMessage = 'Actualizando información...',
    successMessage = 'Acción completada',
    errorMessage = 'Ocurrió un error',
    loadingIcon = 'pi pi-shopping-cart',
    successIcon = 'pi pi-check-circle',
    errorIcon = 'pi pi-times-circle'
}) {
    const isSuccess = status === 'success';
    const isError = status === 'error';
    const style = fullScreen
        ? { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: overlayTint, zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: `blur(${overlayBlur})`, WebkitBackdropFilter: `blur(${overlayBlur})`, pointerEvents: blockInteraction ? 'auto' : 'none' }
        : coverParent
        ? { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: overlayTint, zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: `blur(${overlayBlur})`, WebkitBackdropFilter: `blur(${overlayBlur})`, pointerEvents: blockInteraction ? 'auto' : 'none' }
        : { display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'transparent', pointerEvents: blockInteraction ? 'auto' : 'none' };

    return (
        <div className="flex flex-column justify-content-center align-items-center py-6" style={style} aria-busy={status === 'loading'} aria-label={isError ? 'Error' : isSuccess ? 'Completado' : 'Cargando'}>
            {isSuccess ? (
                <div
                    className="flex justify-content-center align-items-center"
                    style={{
                        width: `${size}px`,
                        height: `${size}px`,
                        borderRadius: '999px',
                        background: '#dcfce7',
                        color: '#15803d'
                    }}
                >
                    <i className={successIcon} style={{ fontSize: `${Math.max(28, size * 0.48)}px` }} />
                </div>
            ) : isError ? (
                <div
                    className="flex justify-content-center align-items-center"
                    style={{
                        width: `${size}px`,
                        height: `${size}px`,
                        borderRadius: '999px',
                        background: '#fee2e2',
                        color: '#b91c1c'
                    }}
                >
                    <i className={errorIcon} style={{ fontSize: `${Math.max(28, size * 0.48)}px` }} />
                </div>
            ) : (
                <div
                    className="flex justify-content-center align-items-center"
                    style={{ position: 'relative', width: `${size}px`, height: `${size}px` }}
                >
                    <ProgressSpinner strokeWidth={strokeWidth} style={{ width: `${size}px`, height: `${size}px` }} animationDuration={animationDuration} />
                    <i
                        className={loadingIcon}
                        style={{
                            position: 'absolute',
                            fontSize: `${Math.max(20, size * 0.34)}px`,
                            color: '#1d4ed8'
                        }}
                    />
                </div>
            )}
            <span className="font-medium" style={{ color: getCompany().primaryColor }}>{isSuccess ? successMessage : isError ? errorMessage : loadingMessage}</span>
        </div>
    );
}
